import React, { useMemo } from "react";
import { types } from "@costar-suite/core";
import { GridViewLayout } from "@costar-search-x/components";
import { Resources } from "@/app/i18n/src";
import { itemId } from "@costar-search-x/core";
import Link from "next/link";
import { RowRenderable, renderRowWithLink } from "../shared/constants";

const Name = ({ name }: { name: string }) => (
  <div className="flex items-center text-primary hover:underline">
    <div className="line-clamp-1" title={name}>
      {name}
    </div>
  </div>
);

const onClickUrl = (row: RowRenderable) =>
  `/annuaire/societes/${row?.[itemId]}/${row?.urlSlug}/resume`;

const renderRow = renderRowWithLink(onClickUrl);

export const useLocationGridLayout = (
  resources: Resources | undefined
): GridViewLayout | undefined => {
  return useMemo(
    () =>
      resources && {
        entityTag: types.CentralUserEntities.UserEntityTag.listviewlayout,
        groupTag: undefined,
        columns: [
          {
            key: "name",
            title: resources.locations.grid.companies(),
            width: 300,
            fixed: "left",
            render: (value, row) => {
              return (
                <Link href={onClickUrl(row)}>
                  <Name name={row.name} />
                </Link>
              );
            },
          },
          // temp
          // {
          //   key: "sectorOfActivity",
          //   title: resources.grid.sectorOfActivity(),
          //   width: 275,
          //   ellipsis: true,
          //   render: renderRow,
          // },
          {
            key: "address",
            title: resources.grid.address(),
            width: 250,
            ellipsis: true,
            render: renderRow,
          },
          {
            key: "city",
            title: resources.grid.city(),
            width: 200,
            ellipsis: true,
            render: renderRow,
          },
          {
            key: "postalCode",
            title: resources.locations.grid.postalCode(),
            width: 150,
            ellipsis: true,
            render: renderRow,
          },
          {
            key: "country",
            title: resources.grid.country(),
            width: 175,
            ellipsis: true,
            render: renderRow,
          },
          {
            key: "numberOfCollaborators",
            title: resources.grid.numberOfEmployees(),
            width: 150,
            ellipsis: true,
            render: renderRow,
            align: "right",
          },
        ],
      },
    [resources]
  );
};
